import { Link } from 'react-router-dom';
import { siteData } from '../../data/mock';

const FooterLink = ({ href, className, style, children }) => {
  const isInternal = href.startsWith('/');
  if (isInternal) {
    return <Link to={href} className={className} style={style}>{children}</Link>;
  }
  return <a href={href} className={className} style={style}>{children}</a>;
};

export const Footer = () => {
  const { footer } = siteData;

  return (
    <footer className="py-14 lg:py-16 bg-stone-900">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10">
          {/* Brand */}
          <div className="max-w-[280px]">
            <Link
              to="/"
              className="font-heading text-[1.1rem] font-bold text-white tracking-tight"
            >
              {footer.logo}
            </Link>
            <p className="mt-2.5 text-[0.84rem] text-stone-500 leading-relaxed">
              {footer.tagline}
            </p>
          </div>

          {/* Link Sections */}
          <div className="flex flex-wrap gap-16">
            {footer.sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-[0.75rem] font-semibold text-stone-500 uppercase tracking-wider mb-4">
                  {section.title}
                </h4>
                <nav className="flex flex-col gap-2.5">
                  {section.links.map((link) => (
                    <FooterLink
                      key={link.label}
                      href={link.href}
                      className="text-[0.84rem] text-stone-400 hover:text-white"
                      style={{ transition: 'color 0.2s' }}
                    >
                      {link.label}
                    </FooterLink>
                  ))}
                </nav>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-stone-800">
          <p className="text-[0.78rem] text-stone-600">{footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};
